"use client"

interface Subject {
  name: string
  type: "Compulsory" | "Optional"
}

interface GradeLevel {
  level: string
  subjects: Subject[]
}

interface LearningJourneyProps {
  gradeLevels: GradeLevel[]
}

export function LearningJourney({ gradeLevels }: LearningJourneyProps) {
  const getTypeColor = (type: string) => {
    return type === "Compulsory"
      ? "bg-green-200 text-teal-600"
      : "bg-yellow-200 text-yellow-800"
  }

  return (
    <div className="bg-slate-100 p-6 sm:p-8 rounded-2xl shadow-lg">
      <div className="flex items-center gap-4 mb-6 bg-slate-100">
        <div className="p-3 bg-slate-200 rounded-full">
          <span className="text-slate-200">🎓</span>
        </div>
        <h2 className="text-2xl font-bold text-slate-900">Your Learning Journey</h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 bg-">
        {gradeLevels.map((grade) => (
          <div key={grade.level} className="bg-slate-50 p-4 rounded-xl">
            <h3 className="font-bold text-lg text-slate-700 mb-4 bg-slate-50">{grade.level}</h3>
            <div className="space-y-3">
              {grade.subjects.map((subject) => (
                <div key={subject.name} className="flex items-center justify-between">
                  <span className="text-slate-600">{subject.name}</span>
                  <span className={`text-xs font-semibold px-2 py-1 rounded-full ${getTypeColor(subject.type)}`}>
                    {subject.type}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
